import { FC } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Routes } from "router";
import Logo from "src/assets/logo/panorama-studio-logo.svg?react";
import { Link, Typography } from "theme";
import { ArrowDown, ArrowLeft, ArrowUp } from "theme/icons";

import { Box, Grid2 } from "@mui/material";
import { styled } from "@mui/material/styles";

import { LayoutProps } from "../Layout/Layout.tsx";

const HeaderWrapper = styled("header")(({ theme }) => ({
  position: "sticky",
  top: 0,
  left: 0,
  width: "100%",
  paddingBottom: theme.spacing(1),
  backgroundColor: theme.palette.background.primary,
  zIndex: 2,
}));

const StyledGoBackButton = styled("button")(({ theme }) => ({
  background: "none",
  border: "none",
  margin: 0,
  padding: theme.spacing(0.75),
  cursor: "pointer",
}));

type HeaderProps = Pick<
  LayoutProps,
  "isPreviousStepAvailable" | "isSkipStepAvailable" | "prevStepUrl"
>;

const StyledButton = styled("button")(({ theme }) => ({
  background: "none",
  border: "none",
  margin: 0,
  padding: theme.spacing(1, 0.5),
  cursor: "pointer",
}));

const Header: FC<HeaderProps> = ({ isPreviousStepAvailable, isSkipStepAvailable, prevStepUrl }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [newParams] = useSearchParams();

  const isAboutCompanyPageOpen = pathname === Routes.AboutCompany;
  const previousUrl = newParams.get("previousStepUrl")
    ? window.location.href.split("!")?.[1]
    : Routes.BookingCreation;

  return (
    <HeaderWrapper>
      <Link
        to={
          isAboutCompanyPageOpen
            ? previousUrl
            : `${Routes.AboutCompany}?previousStepUrl=!${pathname}?${newParams.toString()}`
        }
      >
        <Grid2 container alignItems="center" columnGap={1.5}>
          <Box>
            <Grid2 container flexDirection="column" rowGap={0.5}>
              <Logo />
              <Typography variant="body2" color="black">
                Вул Жовківська 14, м. Львів, Україна
              </Typography>
            </Grid2>
          </Box>
          {isAboutCompanyPageOpen ? <ArrowUp /> : <ArrowDown />}
        </Grid2>
      </Link>
      {(isSkipStepAvailable || isPreviousStepAvailable) && (
        <Grid2 mt={1} container justifyContent="space-between" alignItems="center">
          <Box>
            {isPreviousStepAvailable && (
              <StyledGoBackButton onClick={() => navigate(`${prevStepUrl}`)}>
                <ArrowLeft />
              </StyledGoBackButton>
            )}
          </Box>

          {isSkipStepAvailable && (
            <StyledButton
              onClick={() =>
                navigate(`${Routes.BookingCreationBookingDetailPreview}?${newParams.toString()}&e=`)
              }
            >
              <Typography
                variant="body2"
                textTransform="uppercase"
                color="primary"
                weight="semiBold"
              >
                Пропустити
              </Typography>
            </StyledButton>
          )}
        </Grid2>
      )}
    </HeaderWrapper>
  );
};

export default Header;
